import { useState, useRef } from 'react';

const tabs = [
  { id: 'business', label: '🏢 Business Info' },
  { id: 'profile', label: '👤 Profile Update' },
  { id: 'login', label: '🔐 Login & Password' },
  { id: 'invoice', label: '🧾 Invoice Defaults' },
  { id: 'notifications', label: '🔔 Notifications' },
];

export default function Settings() {
  const [tab, setTab] = useState('business');
  const [newPass, setNewPass] = useState('');
  const [confirmPass, setConfirmPass] = useState('');
  const [passMsg, setPassMsg] = useState('');
  const [notifs, setNotifs] = useState({ overdue: true, deadline: true, newClient: false, weekly: true });
  const [profilePic, setProfilePic] = useState(null);
  const fileRef = useRef(null);

  const changePassword = () => {
    if (newPass.length < 6) { setPassMsg('Password must be at least 6 characters.'); return; }
    if (newPass !== confirmPass) { setPassMsg('Passwords do not match.'); return; }
    setPassMsg('✅ Password changed successfully!');
  };

  const handlePicUpload = (e) => {
    const file = e.target.files[0];
    if (!file) return;
    const reader = new FileReader();
    reader.onload = (ev) => setProfilePic(ev.target.result);
    reader.readAsDataURL(file);
  };

  return (
    <div>
      <div className="d-settings-tabs">
        {tabs.map(t => (
          <button key={t.id} className={`d-settings-tab${tab === t.id ? ' active' : ''}`} onClick={() => setTab(t.id)}>{t.label}</button>
        ))}
      </div>

      {tab === 'business' && (
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 16 }}>
          <div className="d-card">
            <div className="d-ctitle">Business Info</div>
            {[
              ['Brand Name', 'LathiNyx DevLabs'],
              ['Your Name', 'Aryan'],
              ['Title', 'Founder of LathiNyx DevLabs'],
              ['Designation', 'Full Stack Developer & AI Specialist'],
              ['Email', 'lathinyxdevlabs@gmail.com'],
              ['Website', 'https://lathinyxdevlabs.com'],
              ['Address', 'Patna, Bihar, India'],
            ].map(([label, val]) => (
              <div key={label} className="d-fg">
                <div className="d-flabel">{label}</div>
                <input className="d-finput" defaultValue={val} />
              </div>
            ))}
            <button className="d-btn d-btn-primary" style={{ width: '100%', marginTop: 6 }} onClick={() => alert('Settings saved!')}>Save Settings</button>
          </div>
          <div className="d-card">
            <div className="d-ctitle">Brand Links</div>
            {[
              ['Primary Website', 'https://lathinyxdevlabs.com'],
              ['Portfolio Link', 'https://lathinyxdevlabs.com/portfolio'],
              ['LinkedIn', ''],
              ['GitHub', ''],
              ['Instagram', ''],
            ].map(([label, val]) => (
              <div key={label} className="d-fg">
                <div className="d-flabel">{label}</div>
                <input className="d-finput" defaultValue={val} placeholder="https://..." />
              </div>
            ))}
            <button className="d-btn d-btn-primary" style={{ width: '100%', marginTop: 6 }} onClick={() => alert('Links saved!')}>Save Links</button>
          </div>
        </div>
      )}

      {tab === 'profile' && (
        <div className="d-card" style={{ maxWidth: 540 }}>
          <div className="d-ctitle">Update Profile</div>
          <div style={{ display: 'flex', alignItems: 'center', gap: 16, marginBottom: 20 }}>
            <div style={{ position: 'relative' }}>
              <div style={{ width: 80, height: 80, borderRadius: '50%', background: 'linear-gradient(135deg,#1800ad,#3b2fff)', color: '#fff', fontSize: 26, fontWeight: 800, display: 'flex', alignItems: 'center', justifyContent: 'center', overflow: 'hidden', border: '3px solid #e5e4f0' }}>
                {profilePic ? <img src={profilePic} alt="Profile" style={{ width: '100%', height: '100%', objectFit: 'cover' }} /> : 'AR'}
              </div>
              <button
                onClick={() => fileRef.current.click()}
                style={{ position: 'absolute', bottom: 0, right: 0, width: 26, height: 26, borderRadius: '50%', background: '#ff7c90', border: '2px solid #fff', cursor: 'pointer', fontSize: 12, display: 'flex', alignItems: 'center', justifyContent: 'center' }}
              >📷</button>
              <input ref={fileRef} type="file" accept="image/*" style={{ display: 'none' }} onChange={handlePicUpload} />
            </div>
            <div>
              <div style={{ fontSize: 14, fontWeight: 700, color: '#1a1a1a' }}>Profile Photo</div>
              <div style={{ fontSize: 12, color: '#666', marginTop: 3 }}>JPG, PNG — max 2MB</div>
              <button className="d-btn" style={{ marginTop: 8, fontSize: 11 }} onClick={() => fileRef.current.click()}>📷 Upload Photo</button>
            </div>
          </div>
          {[
            ['Display Name', 'Aryan'],
            ['Title', 'Founder of LathiNyx DevLabs'],
            ['Designation', 'Full Stack Developer & AI Specialist'],
            ['Email', 'lathinyxdevlabs@gmail.com'],
            ['Location', 'Patna, Bihar, India'],
          ].map(([label, val]) => (
            <div key={label} className="d-fg">
              <div className="d-flabel">{label}</div>
              <input className="d-finput" defaultValue={val} />
            </div>
          ))}
          <div className="d-fg">
            <div className="d-flabel">Bio</div>
            <textarea className="d-finput" rows={3} defaultValue="Building professional websites, training AI models, and supporting research under LathiNyx DevLabs." />
          </div>
          <button className="d-btn d-btn-primary" style={{ width: '100%', marginTop: 8 }} onClick={() => alert('Profile updated!')}>Save Profile</button>
        </div>
      )}

      {tab === 'login' && (
        <div className="d-card" style={{ maxWidth: 480 }}>
          <div className="d-ctitle">Login Details & Password</div>
          <div className="d-fg"><div className="d-flabel">Current Email</div><input className="d-finput" defaultValue="lathinyxdevlabs@gmail.com" /></div>
          <div className="d-fg"><div className="d-flabel">New Email (optional)</div><input className="d-finput" type="email" placeholder="new@email.com" /></div>
          <hr style={{ margin: '16px 0', border: 'none', borderTop: '1px solid #e5e4f0' }} />
          <div style={{ fontSize: 13, fontWeight: 700, color: '#1a1a1a', marginBottom: 12 }}>Change Password</div>
          <div className="d-fg"><div className="d-flabel">Current Password</div><input className="d-finput" type="password" placeholder="••••••••" /></div>
          <div className="d-fg"><div className="d-flabel">New Password</div><input className="d-finput" type="password" value={newPass} onChange={e => setNewPass(e.target.value)} placeholder="Min 6 characters" /></div>
          <div className="d-fg"><div className="d-flabel">Confirm New Password</div><input className="d-finput" type="password" value={confirmPass} onChange={e => setConfirmPass(e.target.value)} /></div>
          {passMsg && <div style={{ fontSize: 13, marginBottom: 10, color: passMsg.includes('✅') ? '#1a7a52' : '#d63a55', fontWeight: 600 }}>{passMsg}</div>}
          <button className="d-btn d-btn-primary" style={{ width: '100%' }} onClick={changePassword}>Update Password</button>
        </div>
      )}

      {tab === 'invoice' && (
        <div className="d-card" style={{ maxWidth: 480 }}>
          <div className="d-ctitle">Invoice Defaults</div>
          <div className="d-fg"><div className="d-flabel">Invoice From Name</div><input className="d-finput" defaultValue="Aryan" /></div>
          <div className="d-fg"><div className="d-flabel">Invoice Prefix</div><input className="d-finput" defaultValue="INV-2026-" /></div>
          <div className="d-fg"><div className="d-flabel">Payment Terms</div>
            <select className="d-finput">
              <option>Net 7 days</option>
              <option defaultValue>Net 15 days</option>
              <option>Net 30 days</option>
              <option>Immediate</option>
            </select>
          </div>
          <div className="d-fg"><div className="d-flabel">Currency</div>
            <select className="d-finput"><option>₹ INR</option><option>$ USD</option></select>
          </div>
          <div className="d-fg"><div className="d-flabel">Payment Email</div><input className="d-finput" defaultValue="lathinyxdevlabs@gmail.com" placeholder="Payment contact email" /></div>
          <button className="d-btn d-btn-primary" style={{ width: '100%', marginTop: 6 }} onClick={() => alert('Invoice defaults saved!')}>Save Defaults</button>
        </div>
      )}

      {tab === 'notifications' && (
        <div className="d-card" style={{ maxWidth: 480 }}>
          <div className="d-ctitle">Notification Preferences</div>
          <div style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
            {[
              ['overdue', 'Invoice overdue reminders'],
              ['deadline', 'Project deadline alerts'],
              ['newClient', 'New client notifications'],
              ['weekly', 'Weekly revenue summary'],
            ].map(([key, label]) => (
              <label key={key} style={{ display: 'flex', alignItems: 'center', gap: 10, fontSize: 14, color: '#1a1a1a', cursor: 'pointer' }}>
                <input type="checkbox" checked={notifs[key]} onChange={e => setNotifs(p => ({ ...p, [key]: e.target.checked }))} style={{ width: 16, height: 16 }} />
                {label}
              </label>
            ))}
          </div>
          <button className="d-btn d-btn-primary" style={{ marginTop: 20 }} onClick={() => alert('Notification settings saved!')}>Save</button>
        </div>
      )}
    </div>
  );
}
